"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorationPageOptions = exports.dateRangeOptions = void 0;
exports.getCartNotOrderTop5 = getCartNotOrderTop5;
exports.getRealtimeTrend = getRealtimeTrend;
exports.getTradeMetrics = getTradeMetrics;
exports.getUserMetrics = getUserMetrics;
exports.getVisitSourceTop10 = getVisitSourceTop10;
exports.getZonePvClickTrend = getZonePvClickTrend;
exports.getZoneStayDistribution = getZoneStayDistribution;
exports.getZoneUserMetrics = getZoneUserMetrics;
exports.zoneDateRangeOptions = exports.userTypeOptions = exports.orderTypeOptions = void 0;
/** 数据总览 mock（暂无接口；小程序列表走 companyappAutoListApi） */

/** 核心看板时间筛选（对应 type：1今日 2本周 3当月 4当年 5自定义） */
var dateRangeOptions = exports.dateRangeOptions = [{
  label: '自然日',
  value: 1
}, {
  label: '自然周',
  value: 2
}, {
  label: '自然月',
  value: 3
}, {
  label: '当年累计',
  value: 4
}, {
  label: '自定义',
  value: 5
}];

/** 分区看板时间筛选（对应 traffic/data 的 type） */
var zoneDateRangeOptions = exports.zoneDateRangeOptions = [{
  label: '自然日',
  value: 1
}, {
  label: '自然周',
  value: 2
}, {
  label: '自然月',
  value: 3
}, {
  label: '当年累计',
  value: 4
}, {
  label: '自定义',
  value: 5
}];
var decorationPageOptions = exports.decorationPageOptions = [{
  label: '全部',
  value: 'all'
}, {
  label: '首页',
  value: '1'
}, {
  label: '专题页',
  value: '2'
}];
var orderTypeOptions = exports.orderTypeOptions = [{
  label: '全部',
  value: 'all'
}, {
  label: '普通订单',
  value: '1'
}, {
  label: '拼团订单',
  value: '2'
}];
var userTypeOptions = exports.userTypeOptions = [{
  label: '全部用户',
  value: 'all'
}, {
  label: '新用户',
  value: 'new'
}, {
  label: '老用户',
  value: 'old'
}];
function mockCompareList() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var t = Number(type) || 1;
  if (t === 1) return [{
    text: '较昨日',
    rate: '-1.26'
  }];
  if (t === 4) return [{
    text: '年同比',
    rate: '-1.26'
  }];
  return [{
    text: '环比',
    rate: '-1.26'
  }, {
    text: '年同比',
    rate: '-1.26'
  }];
}
function getUserMetrics() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var compareList = mockCompareList(type);
  return {
    dataTime: '2026/08/04 14:00',
    list: [{
      key: 'visitUsers',
      label: '访问人数',
      value: '471',
      unit: '人',
      tip: '今日访问过小程序/页面的独立用户总数。同一用户多次访问只计1次',
      compareList: compareList
    }, {
      key: 'newUsers',
      label: '新增用户',
      value: '78',
      unit: '人',
      tip: '今日首次访问小程序/页面的用户数。即用户生命周期中第一次启动发生在今日',
      compareList: compareList
    }, {
      key: 'payUsers',
      label: '支付用户',
      value: '299',
      unit: '人',
      tip: '今日成功完成支付的独立用户数。同一用户多笔订单计多次',
      compareList: compareList
    }]
  };
}
function getTradeMetrics() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var compareList = mockCompareList(type);
  return {
    dataTime: '2026/08/04 14:00',
    list: [{
      key: 'orderCount',
      label: '净成交订单数',
      value: '399',
      unit: '单',
      tip: '支付成功的订单总笔数。同一用户多笔订单分别计入（订单状态除开“已取消”，“退款成功”）',
      compareList: compareList
    }, {
      key: 'orderAmount',
      label: '净成交订单金额',
      value: '¥9.00',
      unit: '万',
      tip: '支付成功的订单总金额，反映交易规模（订单状态除开“已取消”，“退款成功”，也不包含"部分退款"中已退款商品金额）',
      compareList: compareList
    }, {
      key: 'aov',
      label: '客单价',
      value: '¥56.00',
      unit: '元',
      tip: '每笔订单的平均成交金额，反映用户消费深度',
      compareList: compareList
    }, {
      key: 'newAmount',
      label: '新客户净成交金额',
      value: '¥56.00',
      unit: '元',
      tip: '首次下单用户贡献的成交金额，衡量新客价值（订单状态除开“已取消”，“退款成功”，也不包含"部分退款"中已退款商品金额）',
      compareList: compareList
    }, {
      key: 'oldAmount',
      label: '老客户净成交金额',
      value: '¥56.00',
      unit: '元',
      tip: '历史有成交记录的用户贡献的成交金额，衡量老客贡献（订单状态除开“已取消”，“退款成功”，也不包含"部分退款"中已退款商品金额）',
      compareList: compareList
    }, {
      key: 'orderCvr',
      label: '下单转化率',
      value: '72',
      unit: '%',
      tip: '访问用户中成功提交订单的比例，反映从访问到下单的效率',
      compareList: compareList
    }, {
      key: 'payCvr',
      label: '支付转化率',
      value: '72',
      unit: '%',
      tip: '访问用户中成功支付的比例，反映从访问到支付的最终转化效率',
      compareList: compareList
    }, {
      key: 'refundAmount',
      label: '退款金额',
      value: '¥56.00',
      unit: '元',
      tip: '已退款的订单总金额，反映售后资金流出',
      compareList: compareList
    }, {
      key: 'grossMargin',
      label: '毛利率',
      value: '12',
      unit: '%',
      tip: '成交订单的毛利占成交金额的比例，反映盈利能力',
      compareList: compareList
    }, {
      key: 'afterSale',
      label: '售后申请单量',
      value: '10',
      unit: '',
      tip: '用户售后申请的总单数，反映售后压力',
      compareList: compareList
    }]
  };
}
function getVisitSourceTop10() {
  return {
    dataTime: '2026/08/04 14:00',
    visitUsers: [{
      name: '任务栏',
      value: 919,
      percent: 78.01
    }, {
      name: '手机浏览器',
      value: 152,
      percent: 12.9
    }, {
      name: '发现·小程序',
      value: 87,
      percent: 7.38
    }, {
      name: 'Android系统',
      value: 26,
      percent: 2.2
    }, {
      name: '单聊分享',
      value: 15,
      percent: 1.27
    }, {
      name: 'PC端',
      value: 8,
      percent: 0.67
    }, {
      name: '小程序消息',
      value: 6,
      percent: 0.5
    }, {
      name: '小程序功能',
      value: 3,
      percent: 0.25
    }, {
      name: '收藏',
      value: 2,
      percent: 0.16
    }],
    openTimes: [{
      name: '任务栏',
      value: 1820,
      percent: 72.4
    }, {
      name: '手机浏览器',
      value: 310,
      percent: 12.3
    }, {
      name: '发现·小程序',
      value: 198,
      percent: 7.9
    }, {
      name: 'Android系统',
      value: 66,
      percent: 2.6
    }, {
      name: '单聊分享',
      value: 40,
      percent: 1.6
    }, {
      name: 'PC端',
      value: 28,
      percent: 1.1
    }, {
      name: '小程序消息',
      value: 22,
      percent: 0.9
    }, {
      name: '小程序功能',
      value: 14,
      percent: 0.55
    }, {
      name: '收藏',
      value: 10,
      percent: 0.4
    }]
  };
}
function getCartNotOrderTop5() {
  return {
    dataTime: '2026/08/04 14:00',
    list: [{
      name: '商品A',
      value: 230
    }, {
      name: '商品B',
      value: 180
    }, {
      name: '商品C',
      value: 150
    }, {
      name: '商品D',
      value: 120
    }, {
      name: '商品E',
      value: 90
    }]
  };
}

/** 分区看板 - 流量指标 */
function getZoneUserMetrics() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var compareList = mockCompareList(type);
  return {
    list: [{
      key: 'clicks',
      label: '点击量',
      value: '9,300',
      unit: '',
      tip: '统计周期内页面点击次数',
      compareList: compareList
    }, {
      key: 'pv',
      label: '浏览PV',
      value: '9,300',
      unit: '',
      tip: '统计周期内页面浏览次数',
      compareList: compareList
    }, {
      key: 'avgStay',
      label: '平均停留时长',
      value: '02:39',
      unit: '',
      tip: '统计周期内用户平均停留时长',
      compareList: compareList
    }]
  };
}

/** 分区看板 - PV · 点击量 趋势 */
function getZonePvClickTrend() {
  var dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '2026/08/10';
  var hours = Array.from({
    length: 24
  }, function (_, i) {
    return "".concat(String(i).padStart(2, '0'), ":00");
  });
  var currentHour = 16;
  var pvRaw = [120, 180, 150, 210, 260, 300, 280, 350, 420, 480, 520, 560, 610, 580, 640, 700, 720];
  var clickRaw = [20, 30, 25, 40, 45, 55, 50, 60, 70, 80, 90, 95, 100, 88, 110, 120, 130];
  return {
    date: dateStr,
    updateTime: '2026-08-10 16:12:05',
    hours: hours,
    pv: hours.map(function (_, i) {
      return i <= currentHour ? pvRaw[i] || null : null;
    }),
    clicks: hours.map(function (_, i) {
      return i <= currentHour ? clickRaw[i] || null : null;
    })
  };
}

/** 分区看板 - 各停留时长分布 */
function getZoneStayDistribution() {
  return {
    updateTime: '2026-08-10 11:52:52',
    list: [{
      name: '3分钟',
      value: 4200
    }, {
      name: '1分钟',
      value: 2400
    }, {
      name: '5分钟',
      value: 1800
    }, {
      name: '0-30秒',
      value: 1200
    }, {
      name: '5分钟以上',
      value: 900
    }]
  };
}

/** 实时访问用户 / 下单订单数（00:00-23:00，当前小时之后为空） */
function getRealtimeTrend() {
  var dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '2026-08-07';
  var hours = Array.from({
    length: 24
  }, function (_, i) {
    return "".concat(String(i).padStart(2, '0'), ":00");
  });
  // 模拟到 09 点有数据
  var currentHour = 9;
  var visitUsers = [150, 220, 190, 210, 200, 180, 170, 250, 280, 240];
  var orderCounts = [21, 24, 22, 28, 27, 25, 20, 19, 18, 16];
  var visitSeries = hours.map(function (_, i) {
    return i <= currentHour ? visitUsers[i] || null : null;
  });
  var orderSeries = hours.map(function (_, i) {
    return i <= currentHour ? orderCounts[i] || null : null;
  });
  return {
    date: dateStr.replace(/-/g, '/'),
    updateTime: '2026-08-07 09:23:00',
    hours: hours,
    visitUsers: visitSeries,
    orderCounts: orderSeries,
    currentHourLabel: '当前时间'
  };
}